import { Industry } from 'src/types';

export const COMPANY_NAME_MAP: Record<Industry, string> = {
  Finance: 'Aurora Fortuna',
  Insurance: 'Zenith Guard',
  Gambling: 'Spinzalot',
  Mobile: 'NostraTel',
  Retail: 'Stridora',
};
